import styled from 'styled-components';

import { ModalContent } from 'components/modal';
import UnstyledButton from 'components/unstyled-button';

export const IconsContainer = styled.div`
  display: flex;
`;

export const StoreIconWrap = styled.div`
  margin: 0 1rem 0 0;
  cursor: pointer;
  line-height: 0;

  &:last-child {
    margin-right: 0;
  }
`;

export const ContentContainer = styled(ModalContent)`
  font-size: 1rem;

  & div.modal-inner {
    max-width: none;
    margin: 0;
    width: 100%;
    text-align: center;
    padding: 3rem 1.5rem 0;
    ${Styles.desktop`
      padding: 6rem 15% 2rem;
    `}
  }

  & div.modal-scroller {
    padding-top: 3rem;
    ${Styles.desktop`
      padding: 0;
    `}
  }
`;

export const UnstyledButtonNoSpacing = styled(UnstyledButton)`
  margin: 0;
  padding: 0;
  line-height: 0;
`;
